import CollectionShelf from './CollectionShelf'
import type { CollectionShelfProps } from './CollectionShelf'

export default CollectionShelf

export type { CollectionShelfProps }
